import React from 'react';
import PropTypes from 'prop-types';

var checkboxCheckedIcon = function checkboxCheckedIcon(_ref) {
  var checked = _ref.checked,
      icon = _ref.icon,
      checkedTick = _ref.checkedTick;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    className: icon,
    focusable: "false",
    shapeRendering: "crispEdges",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("g", {
    className: checked,
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "0"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "14",
    width: "14",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: checkedTick,
    fillRule: "nonzero",
    points: "12 4.22226066 10.6259221 3 5.58277771 8.37894955 3.3179086 6.13993399 2 7.40754746 5.63993779 11"
  })));
};

process.env.NODE_ENV !== "production" ? checkboxCheckedIcon.propTypes = {
  /**
   * A class applied when checked
   */
  checked: PropTypes.string,

  /**
   * A class for the checkbox tick
   */
  checkedTick: PropTypes.string,

  /**
   * A class  for the icon
   */
  icon: PropTypes.string
} : void 0;
export default checkboxCheckedIcon;